export const environment = {
  app: 'zshop-medicare',
  configs: {
    indexRoute: 'shopping',
    defaultRoute: 'medicare',
    useLocalConfig: useLocalConfig,
  },
  production: false,
  squidex: {
    baseUrl: 'https://squidex-production.i1.zipari.cloud',
  },
};
